import React from 'react';
import { CheckCircle2, XCircle, BookOpen, Droplets, Activity, ShoppingCart, LineChart, Gift, UserCheck, UserX } from 'lucide-react';
export function OfferDetails() {
  const features = [{
    icon: <BookOpen className="w-6 h-6 text-brand-teal" data-id="element-75" />,
    title: 'El Manual Maestro Digital',
    desc: 'El paso a paso exacto para desinflamarte en un fin de semana.'
  }, {
    icon: <Droplets className="w-6 h-6 text-brand-teal" data-id="element-76" />,
    title: 'La Receta de la Bebida Isotónica de Rescate',
    desc: 'La mezcla mineral exacta que detiene la retención de líquidos de inmediato.'
  }, {
    icon: <Activity className="w-6 h-6 text-brand-teal" data-id="element-77" />,
    title: 'Protocolo de Activación Vagal',
    desc: '3 maniobras de 60 segundos para bajar el estrés físico sin meditar.'
  }, {
    icon: <ShoppingCart className="w-6 h-6 text-brand-teal" data-id="element-78" />,
    title: 'Lista de Compras de 7 Ingredientes',
    desc: 'Todo lo necesario disponible en cualquier supermercado local.'
  }, {
    icon: <LineChart className="w-6 h-6 text-brand-teal" data-id="element-79" />,
    title: 'Hoja de Seguimiento Pre/Post',
    desc: 'Herramienta visual para medir tus resultados reales en centímetros.'
  }, {
    icon: <Gift className="w-6 h-6 text-brand-amber" data-id="element-80" />,
    title: 'Bonus Especial',
    desc: "Guía '3 Especias que valen por un Ibuprofeno'."
  }];
  return <section className="py-20 bg-brand-bg px-4" data-id="element-81">
      <div className="max-w-4xl mx-auto" data-id="element-82">
        {/* What You Get */}
        <div className="mb-24" data-id="element-83">
          <h2 className="font-serif text-3xl md:text-4xl text-brand-dark mb-12 text-center" data-id="element-84">
            Todo lo que recibes hoy
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-85">
            {features.map((feature, idx) => <div key={idx} className="bg-white p-6 rounded-xl shadow-sm border border-brand-teal/10 flex items-start gap-4" data-id="element-86">
                <div className="bg-brand-tealLight p-3 rounded-lg flex-shrink-0" data-id="element-87">
                  {feature.icon}
                </div>
                <div data-id="element-88">
                  <h3 className="font-bold text-lg text-brand-dark mb-1" data-id="element-89">
                    {feature.title}
                  </h3>
                  <p className="text-brand-dark/70" data-id="element-90">{feature.desc}</p>
                </div>
              </div>)}
          </div>
        </div>

        {/* How it works */}
        <div className="mb-24" data-id="element-91">
          <h2 className="font-serif text-3xl md:text-4xl text-brand-dark mb-12 text-center" data-id="element-92">
            Cómo funciona el protocolo
          </h2>
          <div className="space-y-8 relative before:absolute before:inset-0 before:ml-6 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-transparent before:via-brand-teal/30 before:to-transparent" data-id="element-93">
            <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-94">
              <div className="flex items-center justify-center w-12 h-12 rounded-full border-4 border-white bg-brand-teal text-white font-bold text-xl shadow shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10" data-id="element-95">
                1
              </div>
              <div className="w-[calc(100%-4rem)] md:w-[calc(50%-3rem)] p-6 rounded-xl bg-white shadow-sm border border-brand-teal/10" data-id="element-96">
                <h3 className="font-bold text-xl text-brand-dark mb-2" data-id="element-97">
                  Fase de Preparación (Noche 0)
                </h3>
                <p className="text-brand-dark/70" data-id="element-98">
                  Configuras tu cuerpo para el drenaje linfático profundo
                  mientras duermes.
                </p>
              </div>
            </div>

            <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-99">
              <div className="flex items-center justify-center w-12 h-12 rounded-full border-4 border-white bg-brand-teal text-white font-bold text-xl shadow shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10" data-id="element-100">
                2
              </div>
              <div className="w-[calc(100%-4rem)] md:w-[calc(50%-3rem)] p-6 rounded-xl bg-white shadow-sm border border-brand-teal/10" data-id="element-101">
                <h3 className="font-bold text-xl text-brand-dark mb-2" data-id="element-102">
                  Día 1 (La Purga)
                </h3>
                <p className="text-brand-dark/70" data-id="element-103">
                  Desactivas la señal de alerta del cortisol y liberas el exceso
                  de agua celular estancada.
                </p>
              </div>
            </div>

            <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-104">
              <div className="flex items-center justify-center w-12 h-12 rounded-full border-4 border-white bg-brand-teal text-white font-bold text-xl shadow shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10" data-id="element-105">
                3
              </div>
              <div className="w-[calc(100%-4rem)] md:w-[calc(50%-3rem)] p-6 rounded-xl bg-white shadow-sm border border-brand-teal/10" data-id="element-106">
                <h3 className="font-bold text-xl text-brand-dark mb-2" data-id="element-107">
                  Día 2 (El Sellado)
                </h3>
                <p className="text-brand-dark/70" data-id="element-108">
                  Reparas la barrera intestinal y recuperas la movilidad
                  articular y la claridad mental.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Who it's for / not for */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-109">
          <div className="bg-white p-8 rounded-2xl shadow-sm border-t-4 border-brand-teal" data-id="element-110">
            <div className="flex items-center gap-3 mb-6" data-id="element-111">
              <UserCheck className="w-8 h-8 text-brand-teal" data-id="element-112" />
              <h3 className="font-serif text-2xl text-brand-dark" data-id="element-113">
                Para quién es
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-114">
              {["Mujeres y hombres de 45 a 65+ años que se sienten 'pesados' constantemente.", 'Personas que sufren de rigidez articular matutina en manos, pies o espalda.', 'Quienes notan que su abdomen se hincha drásticamente después de comer o al final del día.', "Aquellos que han probado dietas y ejercicio pero no logran bajar la 'inflamación visual'."].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-115">
                  <CheckCircle2 className="w-5 h-5 text-brand-teal shrink-0 mt-0.5" data-id="element-116" />
                  <span className="text-brand-dark/80" data-id="element-117">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-sm border-t-4 border-red-400" data-id="element-118">
            <div className="flex items-center gap-3 mb-6" data-id="element-119">
              <UserX className="w-8 h-8 text-red-400" data-id="element-120" />
              <h3 className="font-serif text-2xl text-brand-dark" data-id="element-121">
                Para quién NO es
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-122">
              {['Personas que buscan una píldora mágica para bajar 10 kilos de grasa real en una noche.', 'Quienes no están dispuestos a seguir un orden específico de pasos por solo 48 horas.', 'Personas con condiciones médicas crónicas que se niegan a consultar a su médico antes de un cambio nutricional.'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-123">
                  <XCircle className="w-5 h-5 text-red-400 shrink-0 mt-0.5" data-id="element-124" />
                  <span className="text-brand-dark/80" data-id="element-125">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}